module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/txt-closed-b3802f309c5e4f66b6e3c8b683b6cd9e.png";